import { feedbackSummarySchema } from '@koderek/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../api/client';

export const FEEDBACK_SUMMARY_KEY = ['admin', 'feedback-summary'];

/** Liczba nowych opinii przy pozycji „Opinie” w menu admina (US-709) – odświeżana co kilka minut. */
export function useFeedbackSummary(enabled: boolean) {
  return useQuery({
    queryKey: FEEDBACK_SUMMARY_KEY,
    queryFn: () => apiGet('/admin/feedback/summary', feedbackSummarySchema),
    enabled,
    refetchInterval: 5 * 60_000,
  });
}
